module.exports = __webpack_public_path__ + "static/images/red-box-lg.8ffd175ea.png";